<div
    class="relative w-full bg-custom-light-grey mt-1 pl-2 rounded-sm"
    (click)="toggleResultDetail()">
    <div class="flex w-full flex-col">
        <app-field-intervention-form-entity-control-results-content
            class="block w-full mt-1"
            [controlResult]="controlResult()"
            (validityChanged)="onValidityChanged($event)" />

        <div
            class="control-result-detail"
            [attr.aria-hidden]="!isControlResultExpanded()"
            [class.control-result-detail--expanded]="isControlResultExpanded()">
            <div class="control-result-detail-content">
                <app-field-intervention-form-entity-control-results-detail [controlResult]="controlResult()" />
            </div>
        </div>
    </div>

    <div
        class="absolute right-0 top-0 grid grid-cols-3 items-center"
        [class]="columnWidthClasses.actions">
        <div class="flex justify-center">
            @if (controlResult().hasControlResultAttentionPoint) {
                <fa-icon
                    class="text-custom-blue"
                    size="lg"
                    [icon]="['fas', 'triangle-exclamation']"
                    [matTooltip]="'attentionPoint' | transloco" />
            }
        </div>

        <div class="flex justify-center">
            <app-icon-button
                iconSize="lg"
                [color]="controlResult().comment ? 'var(--custom-blue)' : undefined"
                [hoverColor]="'var(--secondary)'"
                [icon]="['fas', controlResult().comment ? 'comment-dots' : 'comment-plus']"
                (click)="openCommentDialog($event)" />
        </div>

        <div class="flex justify-center">
            <app-icon-button
                class="detail-toggle"
                iconSize="lg"
                [class.detail-toggle--expanded]="isControlResultExpanded()"
                [hoverColor]="'var(--secondary)'"
                [icon]="['far', 'arrow-left']"
                (click)="toggleResultDetail($event)" />
        </div>
    </div>
</div>
